import PropTypes from "prop-types";
import { htmlToJsx } from "../../../../Utils/Helpers";

const Step1 = ({ context, setActiveNextLevel }) => {
  return (
    <div className='row'>
      <div className='col-12'>
        <div className='d-flex flex-column'>
          <h1 className='text-dark f-15 font-weight-bold my-3'>
            استان محل برگزاری : {context.competition?.province?.name}
          </h1>
          <span className='text-dark f-15 font-weight-bold my-3'>
            آدرس محل برگزاری : {context.competition?.address}
          </span>
        </div>
      </div>
      <div className='col-12'>
        {htmlToJsx(context?.competition?.description)}
      </div>
    </div>
  );
};

Step1.propType = {
  context: PropTypes.object,
  setActiveNextLevel: PropTypes.func,
};

export default Step1;
